export const transformList = (raw) => ({
  id: raw?.id || '',
  name: raw?.name || '',
});
